export default __webpack_public_path__ + "static/media/btn-zeroback-start-se_se@3x.0e0015ec.png";